// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3g5Rq","label":"Labeled_label__OcfS3","divider":"Labeled_divider__1vaNE"};